import { NetworkLookup } from './network-lookup'

export interface NetworkStatus {
  imsi: string,
  rat: number
  isOnline: boolean,
  network: NetworkLookup[],
  lastSeen?: string,
  hasFolder?: boolean
}